export default function MapleGroveAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Maple Grove Post Office",
      address: "9375 Deerwood Ln N, Maple Grove, MN 55369",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(763) 420-3122",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Maple Grove and northwest Hennepin County.",
    },
    {
      name: "Brooklyn Park Post Office",
      address: "5330 85th Ave N, Brooklyn Park, MN 55443",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 566-1040",
      notes: "Convenient for Brooklyn Park and nearby Maple Grove residents. Passport photos available. Call ahead for appointment availability.",
    },
    {
      name: "Osseo Post Office",
      address: "255 2nd Ave SE, Osseo, MN 55369",
      hours: "Mon–Fri 9:00 AM – 3:00 PM",
      phone: "(763) 425-2220",
      notes: "Serves Osseo and nearby Maple Grove residents. Smaller facility — appointments fill quickly.",
    },
    {
      name: "Minneapolis Main Post Office",
      address: "100 S 1st Ave, Minneapolis, MN 55401",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(612) 330-1444",
      notes: "Primary acceptance facility for downtown Minneapolis and northwest metro residents.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in Maple Grove
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and minors must visit an acceptance clerk in person to submit their application. Maple Grove-area residents can use these facilities — though most travelers using Fast Passport Center ship documents directly to us after their clerk visit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
              </div>
              <div className="mt-3 ml-12 bg-white rounded-md p-3 border border-gray-200">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              Visit the clerk with your sealed envelope, then ship it overnight to Fast Passport Center for expedited processing. We handle the rest — no need to drive to the Chicago Passport Agency for a regional agency appointment.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}